module.exports = __webpack_public_path__ + "img/btn_close.a1eab344.svg";